import axios from "axios";
import {Link} from 'react-router-dom';
import {useState,useEffect} from 'react';
import {baseUrl, userLocation, ipAddress, userName} from './Univ.js'
function Footer(){
    return (
        <footer className="py-3 my-4" style={{ position: 'relative', left: 0, bottom: 0, width: '100%' }}>
        <p className="text-center text-muted">© {new Date().getFullYear()} <a target="_blank" href="http://mgmebuild.com"
        className="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1"><u>MGM eBuild Pvt Ltd</u></a></p>
      </footer>
)
}

export default Footer;